import {captureMessage} from "@sentry/react";
import classnames from "classnames";

// @ts-expect-error TS7016
import Utils from "@/legacy/Utils";
import {CheckStepDef, StepType} from "@/lib/types/checks.ts";
import {TxnNetworkResult, TxnResult} from "@/lib/types/transaction.ts";
import {formatDescription} from "@/pages/alerting/components/details/rca/legacyImports.ts";
import {RCAIfBranches} from "@/pages/alerting/components/details/rca/RCAIfBranches.tsx";
import {RCAStepDetails} from "@/pages/alerting/components/details/rca/RCAStepDetails.tsx";
import {StepRequestsWaterfall} from "@/pages/alerting/components/details/rca/StepRequestsWaterfall.tsx";
import {getNetworkRequests} from "@/pages/alerting/components/details/rca/utils.ts";

interface RCAStepProps {
  idx: number;
  result: TxnResult;
  network: TxnNetworkResult[];
  stepsDef: CheckStepDef[];
  version?: string;
}

/*
Contains a part of transaction utils/editor migration
 */
export const RCAStep = ({idx, result, network, stepsDef, version}: RCAStepProps) => {
  const stepDefTuple = stepsDef.find((step) => step[0] === result.step_def);
  if (!stepDefTuple) {
    captureMessage(`could not find step def for ${result.step_def}`);
    return null;
  }

  const stepDef = stepDefTuple[1];
  const desc = formatDescription(stepDef, result);
  const firstStepIndex = Utils.isVersionGreaterOrEqual(version || "2.0.0", "3.0.1") ? 0 : 1;
  const requests = getNetworkRequests(network, result.step + firstStepIndex);
  return (
    <li
      className={classnames(stepDef.step_type, {
        error: result.error,
        "text-primary": stepDef.step_type === StepType.Command,
        "text-success": stepDef.step_type === StepType.Validation,
      })}
    >
      <span className="me-2 text-muted">{idx + 1}.</span>
      <span className="step fw-semibold" dangerouslySetInnerHTML={{__html: desc}} />
      <span
        className={classnames("response float-end badge", {
          "text-bg-success": !result.error,
          "text-bg-danger": result.error,
        })}
      >
        {result.response_time}ms
      </span>
      {requests.length > 0 && <StepRequestsWaterfall requests={requests} step={idx + 1} />}
      {result.step_def === "C_IF" && <RCAIfBranches result={result} stepsDef={stepsDef} />}
      {result.details && <RCAStepDetails idx={idx} result={result} />}
    </li>
  );
};
